import React, { Suspense, lazy, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { startVideoWithoutPlaying } from 'actions/videoPlayer';

import { selectCurrentVideoId } from 'selectors/videoPlayer';

import VideoSectionCard from '../video-section-card';
import { initForVideo, trackExit, trackShown } from './analytics';

const ViewerInsightsList = lazy(() => import('./list'));

export default ({ onActivate }) => {
  const videoId = useSelector(selectCurrentVideoId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!videoId) {
      return;
    }

    dispatch(startVideoWithoutPlaying());
    initForVideo(videoId);
    trackShown();
  }, [dispatch, videoId]);

  const onExit = e => {
    onActivate(e);
    trackExit();
  };

  return (
    <VideoSectionCard className="viewer-insights">
      <Suspense fallback={<div>Loading...</div>}>
        <ViewerInsightsList onExit={onExit} />
      </Suspense>
    </VideoSectionCard>
  );
};
